/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type PdpSharedBlurbShipping_shipment$ref = any;
type PdpSharedBlurbShipping_shipmentQuote$ref = any;
type PdpSharedShippingInfoLink_viewer$ref = any;
export type SharedContactDealerWrapperRefetchQueryVariables = {
    readonly userId: string;
    readonly fetchUser: boolean;
    readonly itemId: string;
};
export type SharedContactDealerWrapperRefetchQueryResponse = {
    readonly viewer: {
        readonly relevantShipping?: {
            readonly shipmentQuote: {
                readonly " $fragmentRefs": PdpSharedBlurbShipping_shipmentQuote$ref;
            } | null;
            readonly shipment: {
                readonly " $fragmentRefs": PdpSharedBlurbShipping_shipment$ref;
            } | null;
        } | null;
        readonly " $fragmentRefs": PdpSharedShippingInfoLink_viewer$ref;
    } | null;
};
export type SharedContactDealerWrapperRefetchQuery = {
    readonly response: SharedContactDealerWrapperRefetchQueryResponse;
    readonly variables: SharedContactDealerWrapperRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchUser",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userId"
        } as any),
        ({
            "kind": "Variable",
            "name": "itemId",
            "variableName": "itemId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            (v3 /*: any*/)
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SharedContactDealerWrapperRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "PdpSharedShippingInfoLink_viewer",
                            "args": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "relevantShipping",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "RelevantShippingInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PdpSharedBlurbShipping_shipmentQuote",
                                                    "args": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipment",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PdpSharedBlurbShipping_shipment",
                                                    "args": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SharedContactDealerWrapperRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "buyerItemConversation",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "Conversation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "serviceId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "relevantShipping",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "RelevantShippingInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isCustom",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isNew",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "status",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "complimentaryShipping",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "subTotalAmount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "buyerSubTotalAmount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "serviceMethod",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentServiceMethod",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isWhiteGlove",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "serviceMethodType",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "region",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Region",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "apiType",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "code",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "regionName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "regionType",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "handlingTimeDisplay",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "totalAmount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v3 /*: any*/),
                                                        (v5 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "buyerServiceMethodDisplay",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipment",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shippingAddress",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "displayCityStateCountry",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                (v2 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SharedContactDealerWrapperRefetchQuery",
            "id": "app-buyer-finding/234.0.0-2019-09-27T13:34:34.101Z/SharedContactDealerWrapperRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6567d7ab9488937d2d8c4749adb044b6';
export default node;
